// extracted by mini-css-extract-plugin
module.exports = {"status":"status-module--status--f1PYx","status__text":"status-module--status__text--LFoJQ"};